import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrioritiesComponent } from './priorities.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCererePriorityComponent } from './add-cerere-priority/add-cerere-priority.component';
import { EditCererePriorityComponent } from './edit-cerere-priority/edit-cerere-priority.component';

@NgModule({
    declarations: [
        PrioritiesComponent,
        AddCererePriorityComponent,
        EditCererePriorityComponent
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [PrioritiesComponent],
})
export class PrioritiesModule { }
